<template>
  <div
    id="main-grid"
    class="grid simple main borderRadius12px"
    style="background: #e5e9ec"
  >
    <div class="well form-group" style="background: #e5e9ec">
      <!-- title -->
      <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
        <h4 style="padding-left: 6px">{{ i18nValues["fieldAdmin"] }}</h4>
        <el-button
          v-if="componentsMap.get('field_create')"
          icon="fas fa-plus"
          size="small"
          class="btn-primary"
          @click="add()"
        >
          {{ i18nValues["add"] }}
        </el-button>
      </div>

      <!-- form -->
      <div class="grid-body no-border borderBottom">
        <el-form>
          <div class="filters-wrapper">
            <div class="filters-row">
              <!-- search by name -->
              <el-form-item :label="i18nValues['name']" prop="name">
                <el-input
                  v-model="filter.name"
                  :placeholder="i18nValues['name']"
                ></el-input>
              </el-form-item>

              <!-- search button  -->
              <el-button
                @click="retrieveFieldsBySearch()"
                icon="fas fa-search"
                id="searchButton"
                size="small"
                class="btn-primary"
              >
                {{ i18nValues["search"] }}
              </el-button>
            </div>
          </div>
        </el-form>

        <div class="full-width" style="margin:0 auto;padding:20px;">
          <el-table
            :key="tableSortKey"
            :data="FieldsSubList"
            id="FieldsTable"
            class="table table-hover"
            align="center"
            row-key="id"
            :empty-text="i18nValues['noDataAvailable']"
            :tree-props="{ children: 'fieldLots' }"
            :default-sort="tableDefaultSort"
            stripe
            @sort-change="handleSortChange"
          >
            <!-- Field Name -->
            <el-table-column
              prop="name"
              :label="i18nValues['name']"
              width="75"
              align="left"
              sortable
            ></el-table-column>

            <!-- Field Batch -->
            <!-- <el-table-column
                            prop="batch" 
                            :label= "i18nValues['batch']"
                            width="75"
                            align="left"
                        ></el-table-column>  -->

            <!-- Field Location -->
            <el-table-column
              prop="location"
              :label="i18nValues['coordenates']"
              width="75"
              align="left"
              sortable
            >
              <template slot-scope="scope">
                <span v-if="scope.row.fieldLots !== undefined">{{ scope.row.location }}</span>
                <span v-else></span>
              </template>
            </el-table-column>

            <!-- EDIT/DELETE -->
            <el-table-column width="90" align="right">
              <template slot-scope="scope">
                <el-button
                  v-if="isReadOnly()"
                  fixed="right"
                  class="text-info"
                  icon="fa fa-eye"
                  size="small"
                  :title="i18nValues['view']"
                  @click="edit(scope.row.id)"
                ></el-button>

                <el-button
                  v-if="
                    scope.row.fieldLots !== undefined &&
                      componentsMap.get('field_modification')
                  "
                  class="text-info"
                  icon="fas fa-edit"
                  size="small"
                  :title="i18nValues['edit']"
                  @click="edit(scope.row.id)"
                ></el-button>

                <el-button
                  v-if="
                    scope.row.fieldLots !== undefined &&
                      componentsMap.get('field_delete')
                  "
                  class="text-danger"
                  icon="fas fa-times"
                  size="small"
                  :title="i18nValues['remove']"
                  @click="deleteField(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>

          <div v-if="90 > 10" style="height: 15px"></div>
          <div class="pagination-bar">
            <PaginationFunctional
              ref="pagination"
              sublistName="FieldsSubList"
              :fullList="FieldsList"
              :tableSize="20"
              :tableIndexInitial="initialPage"
              @paginationChange="paginationChange"
              @currentIndexPagination="setCurrentPage"
              class="text-center"
            />
            <div v-if="FieldsList.length > 0" class="results-info">
              <p>
                {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue";
export default {
  name: "FieldAdmin",
  created() {
    this.restoreFromQuery();
    this.runInitialSearchIfFiltersPresent();
    this.retrieveFieldCount();
  },

  components: {
    PaginationFunctional,
  },

  computed: {
    loading: get("field/loading"),

    // Pagination helpers for results label
    currentPage() {
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
        return this.$refs.pagination.tableIndex;
      }
      return this.initialPage || 1;
    },
    pageSize() {
      return 20; // Keep in sync with PaginationFunctional :tableSize
    },
    totalRecords() {
      if (Array.isArray(this.FieldsList)) {
        return this.FieldsList.length;
      }
      return typeof this.cantidad === "number" ? this.cantidad : 0;
    },
    startIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const start = (this.currentPage - 1) * this.pageSize + 1;
      return Math.min(start, this.totalRecords);
    },
    endIndexDisplay() {
      if (this.totalRecords === 0) return 0;
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },

    tableDefaultSort() {
      if (this.sortProp && this.sortOrder) {
        return { prop: this.sortProp, order: this.sortOrder };
      }
      return {};
    },

    tableSortKey() {
      // Key changes when sort changes, forcing table to re-render with new default-sort
      return `${this.sortProp || 'none'}-${this.sortOrder || 'none'}`;
    },
  },

  props: {
    componentsMap: {},
  },

  data() {
    return {
      field: {},

      FieldsList: [],
      FieldsSubList: [],

      filter: {
        name: null,
      },
      initialPage: 1,
      sortProp: null,
      sortOrder: null,
      isUpdatingRoute: false,
    };
  },

  methods: {
    add() {
      this.$router.push({
        name: `FieldEdition`,
        params: { id: "0" },
        query: this.$route.query,
      });
    },

    edit(id) {
      this.$router.push({
        name: `FieldEdition`,
        params: { id: id },
        query: this.$route.query,
      });
    },

    retrieveFields({ preservePage = false, targetPage = null } = {}) {
      this.$store.dispatch("field/retrieveFields").then((res) => {
        let processedList = res;
        // Process fieldLots data
        for (var i = 0; i < processedList.length; i++) {
          for (var j = 0; j < processedList[i].fieldLots.length; j++) {
            if (processedList[i].batch == null) {
              processedList[i].batch = processedList[i].fieldLots[j].name;
            } else {
              processedList[i].batch =
                processedList[i].batch +
                "," +
                processedList[i].fieldLots[j].name;
            }
            processedList[i].fieldLots[j].id =
              processedList[i].id + "-" + processedList[i].fieldLots[j].id;
          }
        }
        // Apply sorting if sort parameters are present (before setting FieldsList)
        if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
          const sorted = this.$refs.pagination.handleSortChangePagination({
            prop: this.sortProp,
            order: this.sortOrder
          }, processedList);
          if (Array.isArray(sorted)) {
            processedList = sorted;
          }
        }
        // Set the processed list
        this.FieldsList = processedList;
        
        // Sync pagination after loading - use double nextTick to ensure pagination component has processed the list
        const resolvedTarget = typeof targetPage === "number" && targetPage > 0
          ? targetPage
          : this.initialPage || 1;
        this.$nextTick(() => {
          this.$nextTick(() => {
            if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
              this.$refs.pagination.currentChange(resolvedTarget);
            }
          });
        });
        // Only update route query if not preserving page (to avoid overwriting URL params during initial load)
        if (!preservePage) {
          this.updateRouteQuery();
        }
        // When preservePage is true, the URL already has the correct state, so we don't update it
      });
    },

    retrieveFieldsBySearch(preservePage = false) {
      if (this.filter.name === null || this.filter.name === "") {
        this.retrieveFields({ preservePage });
      } else {
        this.$store
          .dispatch("field/retrieveFieldsBySearch", this.filter)
          .then((res) => {
            let processedList = res;
            // Process fieldLots data
            for (var i = 0; i < processedList.length; i++) {
              for (var j = 0; j < processedList[i].fieldLots.length; j++) {
                if (processedList[i].batch == null) {
                  processedList[i].batch = processedList[i].fieldLots[
                    j
                  ].name;
                } else {
                  processedList[i].batch =
                    processedList[i].batch +
                    "," +
                    processedList[i].fieldLots[j].name;
                }
              }
            }
            
            // Apply sorting if sort parameters are present
            if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
              const sorted = this.$refs.pagination.handleSortChangePagination({
                prop: this.sortProp,
                order: this.sortOrder
              }, processedList);
              if (Array.isArray(sorted)) {
                processedList = sorted;
              }
            }
            
            this.FieldsList = processedList;
            
            const targetPage = preservePage ? this.initialPage || 1 : 1;
            if (!preservePage) {
              this.initialPage = 1;
            }
            
            // Sync pagination after loading
            this.$nextTick(() => {
              this.$nextTick(() => {
                if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                  this.$refs.pagination.currentChange(targetPage);
                }
              });
            });
            
            // Update URL after search
            if (preservePage) {
              this.updateRouteQuery();
            } else {
              this.updateRouteQuery({ page: 1 });
            }
          });
      }
    },

    deleteField(id) {
      this.$confirm(
        "Está seguro que quiere eliminar el campo?",
        "Eliminar Campo",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      ).then(() => {
        this.$store.dispatch("field/deleteField", id).then((res) => {
          if (res.status == "OK") {
            this.$notify.success({
              title: this.i18nValues["success"],
              message: this.i18nValues["deleteField"],
              position: "bottom-right",
            });
            this.runInitialSearchIfFiltersPresent();
            this.retrieveFieldCount();
          } else {
            this.$notify.error({
              title: this.i18nValues["error"],
              message: res.statusDescription,
              position: "bottom-right",
            });
          }
        });
      });
    },

    retrieveFieldCount() {
      this.$store
        .dispatch("field/countFields")
        .then((res) => {
          this.cantidad = res;
        });
    },

    handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      const sortChanged = this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (sortChanged) {
        this.FieldsList = this.$refs.pagination.handleSortChangePagination(event);
        this.initialPage = 1;
        this.updateRouteQuery({
          sortProp: this.sortProp || undefined,
          sortOrder: this.sortOrder || undefined,
          page: 1,
        });
        this.$nextTick(() => {
          if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === 'function') {
            this.$refs.pagination.currentChange(1);
          }
        });
      } else {
        this.FieldsList = this.$refs.pagination.handleSortChangePagination(event);
      }
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.FieldsSubList = evt.list;
      }
      const currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex ? this.$refs.pagination.tableIndex : this.initialPage;
      this.updateRouteQuery({ page: currentIdx });
    },

    setCurrentPage(idx) {
      if (typeof idx === 'number') {
        this.updateRouteQuery({ page: idx });
      }
    },

    hasFiltersInQuery() {
      const q = this.$route.query || {};
      return !!(
        q.name ||
        // Also check component state in case query hasn't updated yet
        (this.filter && this.filter.name)
      );
    },

    runInitialSearchIfFiltersPresent() {
      if (this.hasFiltersInQuery()) {
        this.retrieveFieldsBySearch(true); // preservePage = true when loading from URL
      } else {
        // Even without filters, we need to load fields and preserve page/sort from URL
        this.retrieveFields({ 
          preservePage: true, 
          targetPage: this.initialPage || 1 
        });
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter = this.filter || {};
      if (q.name) this.filter.name = q.name;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    updateRouteQuery(partial) {
      const base = this.buildQueryFromState();
      const next = Object.assign({}, base, partial || {});
      const cleaned = {};
      Object.keys(next).forEach(k => {
        const v = next[k];
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      this.isUpdatingRoute = true;
      const done = () => { this.$nextTick(() => { this.isUpdatingRoute = false; }); };
      this.$router.replace({ query: cleaned }).then(done).catch(done);
    },

    buildQueryFromState() {
      const q = {};
      if (this.filter && this.filter.name) q.name = this.filter.name;
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) q.page = this.$refs.pagination.tableIndex;
      else if (this.initialPage) q.page = this.initialPage;
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      return q;
    },
  },
  watch: {
    $route() {
      this.restoreFromQuery();
      this.$nextTick(() => {
        // Check if filters are present in the URL and run search if needed
        if (this.hasFiltersInQuery()) {
          this.retrieveFieldsBySearch(true); // preservePage = true when loading from URL
        } else {
          // Even without filters, reload fields to preserve page/sort from URL
          this.retrieveFields({ 
            preservePage: true, 
            targetPage: this.initialPage || 1 
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.filters-wrapper {
  margin-bottom: 20px;
}

.filters-row {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filters-row .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

.filters-row .el-input,
.filters-row .el-select {
  width: 180px;
}

.filters-row .el-input >>> .el-input__inner,
.filters-row .el-select >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-date-editor {
  width: 180px;
}

.filters-row .el-date-editor >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

/* Tree table row styling for better visual separation (like PalletAdmin) */
#FieldsTable /deep/ .el-table__row {
  border-bottom: 1px solid #e8eaec;
}

/* Child rows - Element UI tree tables indent child rows with padding-left on first cell */
#FieldsTable /deep/ .el-table__body .el-table__row td:first-child[style*="padding-left"] {
  position: relative;
  border-left: 4px solid #409eff;
  background-color: #f8f9fa;
}

/* Apply background to entire row when first cell is indented */
#FieldsTable /deep/ .el-table__body .el-table__row:has(td:first-child[style*="padding-left"]) {
  background-color: #f8f9fa;
}

/* Fallback for browsers without :has() support - style the row cells */
#FieldsTable /deep/ .el-table__body .el-table__row td:first-child[style*="padding-left"] ~ td {
  background-color: #f8f9fa;
}

/* Stronger border for parent rows to separate groups */
#FieldsTable /deep/ .el-table__body .el-table__row:not(:has(td:first-child[style*="padding-left"])) {
  border-bottom: 2px solid #d0d7de;
}

/* Hover effects */
#FieldsTable /deep/ .el-table__row:hover {
  background-color: #f0f2f5 !important;
}

/* Child rows hover - different color */
#FieldsTable /deep/ .el-table__row:has(td:first-child[style*="padding-left"]):hover {
  background-color: #e8ecf0 !important;
}

/* Fallback hover for child rows */
#FieldsTable /deep/ .el-table__body .el-table__row td:first-child[style*="padding-left"]:hover ~ td,
#FieldsTable /deep/ .el-table__row:hover td:first-child[style*="padding-left"] ~ td {
  background-color: #e8ecf0 !important;
}
</style>

